<vdr-currency-input
  [formControl]="formControl"
  [readonly]="readonly"
  [currencyCode]="currencyCode$ | async"
></vdr-currency-input>
